import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { ENodeTypes, TDocumentTree, TLatestLeaf, TNode } from "../../types";
import { newApiService } from "../../services/api-service";
import { useDocuments } from "../../contexts/DekstopContext";
import LoadingDocument from "../../LoadingDocument";
import { CACHE_KEYS } from "../../hooks/useCache";

import '../../scss/latest-docs.scss';
import '../../../styles/from-editor/lists.scss';
import '../../../styles/from-editor/document-styles.scss';

const LatestTreeLeaf = ({ data: { title, _id, year, nr, type, issuer } }: TLatestLeaf) => {
  const { openDocument } = useDocuments();
  return (
    <div className='lex-latest-doc'>
      <div className='lex-latest-doc-header'>
        <div className='lex-latest-doc-number' onClick={() => openDocument({ id: _id, title })}>
          {nr}/{year}
        </div>
        <div className='lex-latest-doc-issuer'>
          ({issuer})
        </div>
      </div>
      <div className='lex-latest-doc-title text-ellipsis' onClick={() => openDocument({ id: _id, title })}>
        {title}
      </div>
    </div>
  )
}

const LatestDocsMon = ({ children, title, nodeClass, loadArgs }: TNode) => {
  const [leafs, setLeafs] = useState<Record<string, TLatestLeaf[]>>({});

  useEffect(() => {
    if (!loadArgs) return;
    const fetch = async () => {
      const [year, mon_nr, date, count] = loadArgs;
      const data = await newApiService.loadDocTitlesForYearAndMon(year, mon_nr, date, count);
      const groupped = _.groupBy(data as unknown as TLatestLeaf[], 'data.type');

      setLeafs(groupped);
    }
    fetch();
  }, [loadArgs]);

  return (
    <>
      <div className='lex-latest-docs-monitor'>
        {title}
      </div>
      {
        Object.keys(leafs).map(docType =>
          <div key={docType} className='lex-latest-docs-group'>
            <div className="lex-latest-docs-group-title">
              {docType}
            </div>
            <div className="lex-latest-docs-list">
              {
                leafs[docType].map(l => <LatestTreeLeaf key={l.data._id} {...l} />)
              }
            </div>
          </div>
        )
      }
    </>
  )
}

const LatestTreeNode = (props: TNode) => {

  if (props.nodeClass !== 'mon') return (
    <>
      {
        props.children.map((c, idx) =>
          c.type === ENodeTypes.NODE
            ? <LatestTreeNode key={`${idx}-${c.title}`} {...c} />
            : null
        )
      }
    </>
  )

  return <LatestDocsMon {...props} />
}

const LatestDocsDocument = () => {

  const { cache } = useDocuments();

  const docs = useMemo(() => cache.get(CACHE_KEYS.LATEST_DOCS).data as TDocumentTree, [cache]);

  if (cache.isLoading) return <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}><LoadingDocument spin /></div>

  return (
    <div className='document-wrapper' id="ultimele-aparitii">
      <div className='document-body'>
        {
          docs.map((d, idx) =>
            d.type === ENodeTypes.NODE
              ? <LatestTreeNode key={`${idx}-${d.title}`} {...d} />
              : null
          )
        }
      </div>
    </div>
  )
}

export default LatestDocsDocument;
